import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    infoBlock: {
      '&:not(:last-child)': {
        marginBottom: MIDDLE_MARGIN,
      },
    },
    infoTitle: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      marginBottom: SMALL_MARGIN,
      fontSize: 18,
      lineHeight: '22px',
    },
    infoText: {
      color: colorsPalette.gray,
      marginBottom: SMALL_MARGIN / 2,
      fontSize: 16,
      lineHeight: '22px',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        lineHeight: '26px',
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
  }),
);

export default useStyles;
